import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import ReadNews from '../views/ReadNews.vue'

const routes = [
  {
    path: '/:code',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'ReadNews',
    component: ReadNews
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router